import { AuthActionType, SET_AUTH, LOGOUT } from '../actions';
import { AuthType } from '../../types/response';

const initialState: AuthType | null = null;

const authReducer = (state = initialState, action: AuthActionType) => {
  switch (action.type) {
    case SET_AUTH:
      return {
        ...action.payload,
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default authReducer;
